import NewsContent from "../Component/News/NewsContent";
import "./universal.module.css"

const Home = () => {
    return (
        <div>
            <NewsContent />
            
            
        </div>
    );
}

export default Home;